import { useTheme } from 'styled-components';

import * as Styles from './fixedBarTheme.styles';

const FixedBarTheme = () => {
  const theme = useTheme();
  return (
    <Styles.FixedBarTheme id="fixed-bar-theme">
      <img src={theme.logo.path} alt="theme logo" width={theme.logo.width} id="fixed-bar-theme-logo" />
    </Styles.FixedBarTheme>
  );
};

export default FixedBarTheme;
